import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, ClockIcon } from 'lucide-react';
import { MockupTag } from './MockupTag';
import type { Article } from '../../types/content';
interface ArticleCardProps {
  article: Article;
}
export function ArticleCard({
  article
}: ArticleCardProps) {
  return <Link to={`/blog/${article.slug}`} className="group flex h-full flex-col rounded-[28px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-743" data-mp="180qa5jzioons">
      <div className="relative overflow-hidden rounded-[24px]" data-id="element-744" data-mp="fd4507an5byt">
        <img src={article.image} alt="" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-brand group-hover:scale-[1.03]" data-id="element-745" data-mp="fbb0axjl91tg" />
        <MockupTag note="Placeholder image" className="absolute left-3 top-3" data-id="element-746" data-mp="p59xrj8pvxf2" />
        <span className="absolute bottom-3 left-3 rounded-[10px] bg-white px-3 py-1 type-small font-bold text-ink" data-id="element-747" data-mp="3nsnwb0rr4kb8">{article.topic}</span>
        <span className="absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center rounded-[13px] bg-white text-ink transition-colors duration-150 group-hover:bg-brand group-hover:text-white" aria-hidden="true" data-id="element-748" data-mp="ga6y7p3bkl0t">
          <ArrowUpRightIcon className="h-5 w-5" data-id="element-749" data-mp="6jvfuxiw29ae" />
        </span>
      </div>
      <p className="mt-4 inline-flex items-center gap-1.5 type-small text-muted" data-id="element-750" data-mp="2is2qis86rcv">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-751" data-mp="2gpdi0ywd297" />
        {article.readTime}
      </p>
      <h3 className="mt-2 type-card-title text-ink transition-colors duration-150 group-hover:text-brand-press" data-id="element-752" data-mp="3tn08bfdbd6s3">
        {article.title}
      </h3>
      <p className="mt-2 type-card-desc" data-id="element-753" data-mp="3jq5c534ijigz">{article.excerpt}</p>
    </Link>;
}